import { Col, Form, Input, InputNumber, Row, Slider, Typography } from "antd";
import { useState } from "react";
const { TextArea } = Input;

export const DevStageBlock = ({
    title,
    impactName,
    exampleName,
    optimizationRange,
    setOptimizationRange
}) => {

    const [error, setError] = useState("");

    const handleChange = (index, val) => {
        const newRange = [...optimizationRange];
        newRange[index] = val;
        setOptimizationRange(newRange);
        if (!newRange[0] || !newRange[1] || newRange[0] <= 0 || newRange[1] <= 0) {
            setError("Ambos valores deben ser mayores a 0");
        } else {
            setError("");
        }
    };

    return (
        <>
            <Typography.Title style={{ textAlign: "left", margin: "0 0 12px 0" }} level={4}>
                <span style={{ marginRight: 8, fontSize: 22 }}>•</span>
                {title}
            </Typography.Title>
            <Form.Item
                name={impactName}
                label="¿Cómo ayudó Copilot?"
                rules={[{ required: true, message: "Requerido" }]}
                style={{ margin: "0 0 8px 0" }}
            >
                <TextArea name={impactName} autoSize />
            </Form.Item>
            <Form.Item
                name={exampleName}
                label="Ejemplo concreto"
                rules={[{ required: true, message: "Requerido" }]}
                style={{ margin: "0 0 8px 0" }}
            >
                <TextArea name={exampleName} autoSize />
            </Form.Item>
            <Form.Item label="Rango de optimización (%)" required validateStatus={error ? "error" : ""} help={error}>
                <Row align="middle">
                    <Col span={24}>
                        De
                        <InputNumber
                            min={0}
                            max={100}
                            value={optimizationRange[0]}
                            onChange={val => handleChange(0, val)}
                            suffix="%"
                            style={{ width: 80, marginRight: 8 }}
                        />
                        a
                        <InputNumber
                            min={0}
                            max={100}
                            value={optimizationRange[1]}
                            onChange={val => handleChange(1, val)}
                            suffix="%"
                            style={{ width: 80 }}
                        />
                    </Col>
                    <Col span={24}>
                        <Slider
                            range
                            min={0}
                            max={100}
                            step={1}
                            value={optimizationRange}
                            onChange={vals => {
                                setOptimizationRange(vals);
                                if (!vals[0] || !vals[1] || vals[0] <= 0 || vals[1] <= 0) {
                                    setError("Ambos valores deben ser mayores a 0");
                                } else {
                                    setError("");
                                }
                            }}
                            tooltip={{ formatter: value => `${value}%` }}
                            marks={{
                                0: "0%",
                                25: "25%",
                                50: "50%",
                                75: "75%",
                                100: "100%"
                            }}
                        />
                    </Col>
                </Row>
            </Form.Item>
        </>
    );
};